import type { ArticleModule } from 'types/capi/article';

import type { ModuleDisplayType } from '~/events/ModuleImpressionEvent';

export type ModuleImpressionProps = {
  displayType?: ModuleDisplayType;
  itemCount?: number;
};

export function getModuleImpressionProps(
  module: ArticleModule,
  { embedded = false }: { embedded?: boolean } = {}
): ModuleImpressionProps {
  switch (module.type) {
    case 'product-list': {
      const itemCount = module.items.filter((item) => item != null).length;

      return {
        displayType: module.display_type,
        itemCount:
          module.display_type === 'block' ? Math.min(itemCount, 1) : itemCount
      };
    }
    case 'image-grid':
      if (!embedded && module.display_type === 'full-bleed') {
        return {
          displayType: 'full-bleed',
          itemCount: Math.min(module.items.length, 1)
        };
      }

      return { displayType: 'grid', itemCount: module.items.length };
    default:
      return {};
  }
}
